import { type TranslationTree } from '@/i18n/types';

export const messages = {
  tooLong: 'Texto longo demais',
  nameRequired: 'O nome do evento é obrigatório',
  nameShort: 'Use pelo menos 3 caracteres',
  startDateRequired: 'Escolha a data',
  startDatePast: 'Escolha uma data a partir de hoje',
  startTimeInvalid: 'Horário inválido',
  recurrenceUntilInvalid: 'Data inválida',
  recurrenceUntilBeforeStart: 'A data final precisa ser depois da data de início',
  externalUrlInvalid: 'Digite um endereço que comece com https://',
} satisfies TranslationTree;
